import { Card } from '@material-ui/core'
import React, { useContext, useEffect, useRef } from 'react'
import { BARS_BY_LINE, LINE_HEIGHT } from '../util/constants'
import { addTts, getChordsInTtRange, getGlobalLineIndex, getWidthFromTtDuration, substractTts, ttsRangesCollideInclude } from '../util/utils'
import BackingTrackSectionHeader from './BackingTrackSectionHeader'
import EditorBar from './EditorBar'
import EditorChordCard from './EditorChordCard'
import EditorCursor from './EditorCursor'
import { EditorActionType } from './editorStore/backingTrackGeneratorEditorActions'
import BackingTrackGeneratorEditorContext from './editorStore/BackingTrackGeneratorEditorContext'
import { Chord } from './editorStore/backingTrackGeneratorEditorState'


const BackingTrackSection = (props: {
	onPlayClick: (chord: any) => void,
	timeSignature?: any,
	sectionIndex: number,
	onMouseDown: (e: any, lineIndex: number) => void,
	onMouseMove: (e: any, lineIndex: number) => void,
	onClick: (e: any, lineIndex: number) => void,
}) => {

	const {
		onPlayClick,
		timeSignature,
		sectionIndex,
		onMouseDown,
		onMouseMove,
		onClick,
	} = props

	const [editor, dispatchEditor] = useContext(BackingTrackGeneratorEditorContext)

	const section = editor.sections[sectionIndex]

	// const chords = editor.fakeChords || editor.chords

	// const chordsInRange = getChordsInRange(chords, [substractTts(section.transportTime, '1:0'), addTts(section.transportTimeDuration, '2:0')])

	const chordsLines = Array.from(Array(Math.ceil(parseInt(section.transportTimeDuration.split(':')[0]) / BARS_BY_LINE)))

	// TODO : how to handle cursor ranges in 2d absolute
	const cursorRangesLines = Array.from(Array(Math.ceil(parseInt(section.transportTimeDuration.split(':')[0]) / BARS_BY_LINE))).map((_, i: number) =>
		editor.state.cursorRanges.filter((range: [string, string]) => ttsRangesCollideInclude(range, [substractTts(addTts(section.transportTime, (i * BARS_BY_LINE) + ':0'), '1:0'), addTts(BARS_BY_LINE + ':0', '2:0')])))

	// ChordCard Drag

	// TODO : should not be needed
	// const currChordSelectDragLineIndex = useRef<any>(undefined)
	// useEffect(() => {
	// 	console.log({ actL: 'YOYOYO' })
	// 	currChordSelectDragLineIndex.current = editor.state.currChordSelectDragLineIndex
	// }, [editor.state.currChordSelectDragLineIndex])

	const handleCardClick = (e: any, lineIndex: number) => {
		console.log('handleCardClick')
		
		if (editor.fakeChords !== undefined) return// We dont want cursor move if drag is on

		onClick(e, lineIndex)
	}

	// const handleMouseOver = (e: any, lineIndex: number) => {
	// 	if (editor.fakeChords === undefined || lineIndex === editor.state.currChordSelectDragLineIndex) return

	// 	// console.log({ actDragLineIndex: currChordSelectDragLineIndex.current })
	// 	console.log({ actDragLineIndex: editor.state.currChordSelectDragLineIndex, actChordsLines: chordsLines })

	// 	dispatchEditor({
	// 		type: EditorActionType.ChordSelectDragChangeLine,
	// 		payload: {
	// 			lineIndex: getGlobalLineIndex(editor.sections, sectionIndex, lineIndex)
	// 		}
	// 	})
	// }

	// console.log({ actChordsLines: chordsLines })

	return (
		<div
			style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}
		>
			<div style={{ display: 'flex', flexDirection: 'column' }}>

				<BackingTrackSectionHeader
					section={section}
					sectionIndex={sectionIndex}
				/>

				<div style={{ position: 'relative' }}>

					{chordsLines.map((chordsLine: any, lineIndex: number) => (

						// TODO : handle if 9 bars (do not draw 4 EditorBar in this case)
						<Card
							style={{
								display: 'flex',
								marginBottom: 16,
								alignSelf: 'flex-start',
								// position: 'relative',
								width: getWidthFromTtDuration(BARS_BY_LINE.toString()),
								height: LINE_HEIGHT,
								zIndex: 1,
								overflow: 'hidden'
							}}
							onMouseDown={(e: any) => onMouseDown(e, lineIndex)}
							onMouseMove={(e: any) => onMouseMove(e, lineIndex)}

							// onMouseOver={(e: any) => handleMouseOver(e, lineIndex)}

							onClick={(e: any) => handleCardClick(e, lineIndex)}
						>
							{Array.from(Array(BARS_BY_LINE)).map((_, j: number) => (
								<EditorBar
									transportTime={j.toString()}
								/>
							))}
							{cursorRangesLines[lineIndex].map((range: [string, string]) => (
								<EditorCursor
									range={range}
									sectionIndex={sectionIndex}
									lineIndex={lineIndex}
								/>
							))}
						</Card>

					))}

				</div>

			</div>
		</div>
	)
}

export default BackingTrackSection

// DONE : fix chord card no hover when selecting cursor range

// TODO : Enable drag inside of chord card